import {_utils} from "../../utils/_utils.js";
import {initCardsSlider} from "../../utils/cards-slider.js";

/**
 * Gallery hero — "Artfully framed details" (Experience Gallery, TZ section 1):
 * → moves one photo forward, ← one back (see utils/cards-slider.js). Gap 20px.
 */
export const galleryHero = () => {
    return new Promise((resolve) => {
        _utils.initSection('.gallery-hero', (section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const slider = section.querySelector('.gallery-hero__slider');
    if (!slider) return;

    initCardsSlider(
        slider,
        section.querySelector('.gallery-hero__nav-btn--prev'),
        section.querySelector('.gallery-hero__nav-btn--next'),
        {spaceBetween: 20}
    );
};
